
import React from 'react'
import PropTypes from 'prop-types'
import { Button, LoadingSpinner } from '@paypalcorp/pp-react'
import { get, kebabCase } from 'lodash-es'
import { buttonCss, buttonLoadingCss, spinnerCss } from '../style'
import { BUTTON_TYPE } from '@/constants/personalization-studio'

function PsButton({ recommendation = {}, options }) {
  const { onButtonClick, disabled = false, loading = false } = options
  const buttonType = get(recommendation, 'content.buttonType', '')

  const { PRIMARY } = BUTTON_TYPE

  switch (buttonType) {
    case PRIMARY:
      const buttonText = get(recommendation, 'content.buttonTitle', '')
      return (
        <Button
          data-testid={`ps-primary-button-${kebabCase(buttonText)}`}
          onClick={onButtonClick}
          css={[buttonCss, loading && buttonLoadingCss]}
          disabled={disabled}
        >
          {loading ? (
            <div 
              css={spinnerCss}
              style={{
                filter: 'brightness(0) invert(1)', // This will make any color white
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}
            >
              <LoadingSpinner 
                size="sm" 
                screenReaderText="Processing request..." 
              />
            </div>
          ) : (
            buttonText
          )}
        </Button>
      )
    default:
      return null
  }
}

PsButton.propTypes = {
  recommendation: PropTypes.object,
  options: PropTypes.object,
}

export default PsButton
